import * as React from 'react';
import type { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';
import errorReporter from '@app/errorReporter';
import API from 'api';

interface UseSendingReminderProps {
  appointment: BuildJsonType<EnhancedAppointment>;
}

const useSendingReminder = ({ appointment }: UseSendingReminderProps) => {
  const [sendingReminder, setSendingReminder] = React.useState(false);
  const [covid19ReminderSent, setCovid19ReminderSent] = React.useState(
    !!appointment.covid19ReminderSent,
  );

  const sendReminder = async () => {
    setSendingReminder(true);
    try {
      await API.POST.sendCovidReminder(appointment.id);
      setCovid19ReminderSent(true);
    } catch (err) {
      errorReporter.error(err);
    } finally {
      setSendingReminder(false);
    }
  };

  return { sendingReminder, covid19ReminderSent, sendReminder };
};

export default useSendingReminder;
